<template>
    <b-alert
        variant="success"
        dismissible
        fade
        v-if="selectedInvestmentStrategyAboveRecommended"
        :show="checkStrategyRecommendedAlert"
        @dismissed="checkStrategyRecommendedAlert=false">
        {{ $t('investmentStrategyType.aboveRecommendedAlert',
              { investmentHorizon,
                recommendedInvestmentStrategy: $t(`investmentStrategyType.${investmentStrategyRecommendedBasedOnInvestmentHorizon.name}.title`),}) }}
    </b-alert>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'InvestmentStrategy',
    data () {
        return {
            checkStrategyRecommendedAlert: true,
        };
    },
    computed: {
        ...mapGetters(['selectedInvestmentStrategyAboveRecommended', 'isInEditModeWithoutValueChanges']),
        ...mapState(['investmentStrategySelected', 'investmentStrategyRecommendedBasedOnInvestmentHorizon', 'investmentHorizon']),
    },
    watch: {
        investmentStrategySelected (val) {
            this.checkStrategyRecommendedAlert = true;
        },
    },
    methods: {
        hideNotificationIfNeeded () {
            if (this.isInEditModeWithoutValueChanges) {
                this.checkStrategyRecommendedAlert = false;
            }
        },
    },
    mounted () {
        this.hideNotificationIfNeeded();
    },
};
</script>

<style scoped lang="scss">
</style>
